module.exports = __webpack_public_path__ + "img/loading-chromecast.2c012f8b.png";